import React from 'react';
import {View} from 'react-native';

import Screen from '../../../../../shared/components/screen';

import {Props} from './model';
import {useStyles} from '../../../../../shared/hooks/styles';
import {EvenOddList} from '../../../../../shared/components/evenOddList';
import {CustomScrollView} from '../../../../../shared/components/scrollView';

export default ({properties}: Props) => {
  const styles = useStyles(({theme}) => {
    return {
      sectionContainer: {
        marginTop: 32,
        paddingHorizontal: 24,
        paddingBottom: theme.screen.bottomOffset,
      },
      sectionTitle: theme.fonts.h2,
    };
  });

  return (
    <Screen>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
        <View style={styles.sectionContainer}>
          <EvenOddList testIDPrefix='base-info' list={properties} />
        </View>
      </CustomScrollView>
    </Screen>
  );
};
